/* eslint-disable */
import SolicitacaoComentarioApi from '@/Apis/Agendamento/Services/SolicitacaoComentarioApi'
import EventBus from '@/plugins/EventBus'
import { SolicitacaoComentario } from '@/types/_'
import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'ChatComentarioStore' })
export default class ChatSolicitacaoComentarioStore extends VuexModule {
  solicitacaoId = ''
  open = false

  recipientLastSeenDate = ''
  recipientName = ''
  canEdit = true
  loading = false
  utilizaExibicaoDeHistoricoAutorizacao = false

  comentarios: SolicitacaoComentario[] = []

  get isOpen() {
    return this.open
  }

  @Mutation
  setUtilizaExibicaoDeHistoricoAutorizacao(value: boolean) {
    this.utilizaExibicaoDeHistoricoAutorizacao = value
  }

  @Mutation
  setSolicitacaoId(value: string) {
    this.solicitacaoId = value
  }

  @Mutation
  setOpen(value: boolean) {
    this.open = value
  }

  @Action
  async openChatModal(data: IOpenChatModalData) {
    const {
      solicitacaoId = data.solicitacaoId
    } = data
    this.context.commit('setUtilizaExibicaoDeHistoricoAutorizacao', data.utilizaExibicaoDeHistoricoAutorizacao)
    this.context.commit('setOpen', true)
    this.context.commit('setSolicitacaoId', solicitacaoId)
    EventBus.$emit('setLoadingRequest', { status: '', text: 'Carregando...' })
    await this.context.dispatch('loadChatData', 'comentario')
    EventBus.$emit('clearLoadingRequest')
  }

  @Action
  async loadChatData(tipo: string) {
    const [res] = await Promise.all([
      SolicitacaoComentarioApi.getComentariosBySolicitacaoId(this.solicitacaoId, tipo),
    ])
    if (res.success) {
      const data = res.data as SolicitacaoComentario[]
      this.context.commit('setComentarios', data)
    }
  }

  @Action({ commit: 'setComentarios' })
  async getComentariosBySolicitacaoId(solicitacaoId: string, tipo: string) {
    try {
      const request = await SolicitacaoComentarioApi.getComentariosBySolicitacaoId(solicitacaoId, 'comentario')
      if (request.success) this.context.commit('setSolicitacaoId', solicitacaoId)
      return request.success ? request.data : []
    } catch (error) {
      return []
    }
  }

  @Action
  reset() {
    this.context.commit('setSolicitacaoId', '')
    this.context.commit('setComentarios', [])
  }

  @Action
  async setChatData(data: SolicitacaoComentario) {
    return false
  }

  @Action
  async sendComentario(comentario: SolicitacaoComentario) {
    const request = await SolicitacaoComentarioApi.enviarComentario(this.solicitacaoId, comentario)
    if (request.success) {
      this.context.commit('setComentario', comentario)
    }
  }

  @Action
  async closeChatModal() {
    this.context.commit('setOpen', false)
    this.context.dispatch('reset')
  }

  @Mutation
  setComentarios(value: SolicitacaoComentario[]) {
    this.comentarios = value
  }

  @Mutation
  setComentario(value: SolicitacaoComentario) {
    this.comentarios.push(value)
  }

  @Action
  async enviarLembrete(params: any) {
    const request = await SolicitacaoComentarioApi.defineLembrete(params)
    return request
  }

  @Action
  async concluirLembrete() {
    try {
      const request = await SolicitacaoComentarioApi.concluirLembrete(this.solicitacaoId)
      return request
    } catch (error) {
      return {
        success: false,
        message: 'Não foi possível concluir o lembrete',
      }
    }
  }
}

interface IOpenChatModalData {
  solicitacaoId: string;
  utilizaExibicaoDeHistoricoAutorizacao?: boolean;
}
